import WebSocketApi from 'services/WebSocketApi';
import store from 'store';

export function updateMessageStatus(adviseSessionId, messageId, status) {
  return WebSocketApi.instance.invoke({
    _: 'UpdateMessageStatusRequest',
    adviseSessionId,
    messageId,
    status,
  });
}

export function seenAllMessages(adviseSessionId) {
  const messages = store.getState().chatRoom[adviseSessionId];
  if (messages) {
    for (const message of messages) {
      if (
        !message.out &&
        (message.status === 'SENT' || message.status === 'DELIVERED')
      ) {
        updateMessageStatus(adviseSessionId, message.id, 'SEEN');
      }
    }
  }
}
